import { Button } from "@/components/Button";
import { ReactNode } from "react";

interface HomeownersContactCardProps {
  icon: ReactNode;
  title: string;
  text: string;
  buttonText: string;
  buttonIcon?: ReactNode;
  link?: string;
  target?: "_self" | "_blank";
  rel?: ("noopener" | "noreferrer")[];
  onClick?: () => void;
}

export const HomeownersContactCard = ({
  icon,
  title,
  text,
  buttonText,
  buttonIcon,
  link,
  target,
  rel,
  onClick,
}: HomeownersContactCardProps) => {
  return (
    <div className="w-64 h-60 rounded-3xl bg-white border border-gray-200 shadow-sm flex flex-col items-center justify-center gap-2 px-6 flex-shrink-0">
      {icon}
      <p className="text-homeowners-headline font-medium text-lg lg:text-xl text-center">
        {title}
      </p>
      <div>
        <p className="text-homeowners-gray font-light text-center text-[10px] lg:text-xs leading-tight whitespace-pre-line">
          {text}
        </p>
      </div>
      <Button
        size="sm"
        iconLeft
        block
        icon={buttonIcon}
        link={link}
        target={target}
        rel={rel}
        onClick={onClick}
        className="text-white !rounded-xl !bg-homeowners-green !border-none !text-sm !font-medium !gap-2 mt-4 h-10"
      >
        {buttonText}
      </Button>
    </div>
  );
};
